var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_3289_6228)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#545454"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 106,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#545454"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 72,
    width: 13,
    height: 4,
    rx: 2,
    fill: "#545454"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 81,
    width: 9,
    height: 4,
    rx: 2,
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7305 86.3253C42.1993 86.0568 47.4915 83.8164 73.8189 96.0901C73.7421 96.1945 73.7095 96.2439 73.7095 96.2439C73.7095 96.2439 46.3397 105.461 40.9771 94.1061C39.3757 90.7256 39.8346 88.3978 41.6847 86.3515L41.7305 86.3253Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.218 90.9705C124.498 95.7791 115.528 99.2693 106.873 94.6281C108.241 93.7541 109.653 92.854 111.094 91.9228C119.786 86.3379 127.443 90.0748 130.218 90.9705Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.464 31.8293C146.308 80.4913 132.42 89.3229 130.874 90.6644C130.427 91.0528 130.245 91.0245 129.569 90.8502L129.557 90.8568C126.693 90.0974 119.787 86.3375 111.095 91.9217C109.654 92.8529 108.241 93.7531 106.874 94.6271C98.0063 100.251 90.8458 104.214 85.687 101.914C81.3112 99.6815 77.3658 97.7497 73.8189 96.0903C47.4915 83.8166 42.1994 86.0569 41.7305 86.3255C42.2745 86.0292 47.2654 83.2626 53.9856 78.3976C54.0085 78.3845 54.0314 78.3714 54.0363 78.3535C63.0187 71.8438 75.048 61.5853 83.6947 48.389C89.581 39.4155 95.3395 16.6668 106.45 12.2032C129.285 3.68475 139.516 21.9312 140.464 31.8293Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.216 30.9754C115.924 29.1037 115.855 27.3427 115.061 27.042C114.267 26.7412 113.049 28.0148 112.34 29.8864C111.631 31.7581 111.7 33.5192 112.494 33.8199C113.288 34.1206 114.507 32.8471 115.216 30.9754Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.755 33.3635C130.257 31.4262 129.998 29.6829 129.176 29.4698C128.355 29.2567 127.281 30.6544 126.779 32.5918C126.276 34.5291 126.535 36.2724 127.357 36.4855C128.179 36.6986 129.253 35.3009 129.755 33.3635Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.904 40.477C120.785 40.4768 120.67 40.436 120.577 40.3612C120.484 40.2864 120.42 40.1822 120.395 40.0658C120.302 39.6444 119.888 38.3976 119.231 38.2123C118.575 38.027 117.287 38.7464 116.766 39.1239C116.654 39.2051 116.514 39.2384 116.377 39.2165C116.24 39.1947 116.118 39.1194 116.037 39.0072C115.956 38.8951 115.922 38.7553 115.944 38.6186C115.966 38.4818 116.041 38.3594 116.153 38.2782C116.359 38.1295 118.198 36.8358 119.515 37.2074C120.888 37.595 121.365 39.6147 121.415 39.8437C121.431 39.92 121.431 39.999 121.413 40.075C121.395 40.1509 121.36 40.2219 121.311 40.2826C121.262 40.3434 121.2 40.3924 121.13 40.426C121.059 40.4596 120.982 40.477 120.904 40.477H120.904Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3289_6228",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.2985e81a85142b1e6ae277389241a071.svg";
export { ForwardRef as ReactComponent };